/* eslint-disable */
import React, { useState } from 'react'
import SearchSidebar from '../Components/SearchList/SearchSidebar'
import SearchListContent from '../Components/SearchList/SearchListContent'

const SearchList = () => {
    const [contentView, setContentView] = useState("listView");
    const [formData, setFormData] = useState({});


    const handleView = (val, data) => {
        setContentView(val);
        setFormData(data)

    }


    return (
        <>
            <SearchSidebar handleView={handleView} sendFormdata={setFormData} />
            <SearchListContent contentView={contentView} formData={formData} />
        </>
    )
}

export default SearchList